// Before every other import: telemetry wraps what it instruments at import time.
import "./instrument";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { setupTelegram } from "./lib/telegram";
import "./styles.css";

// Theme variables and the viewport must be set up before the first paint.
setupTelegram();

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
